import axios from 'axios';

const handledAxiosResponseStatuses = new Set([400, 401, 403, 404]);
const stripeLoadErrorPattern = /Failed to load Stripe\.js/i;
// Stripe failures are non-actionable only on these reviewed, non-payment routes.
const ignoredStripeLoadErrorRoutes = ['/', '/dashboard', '/signin'];

export const isAxiosNetworkError = (error) =>
  axios.isAxiosError(error) && error.code === 'ERR_NETWORK' && !error.response;

export const isAxiosCancellation = (error) =>
  axios.isAxiosError(error) && (error.code === 'ERR_CANCELED' || axios.isCancel(error));

export const isHandledAxiosResponseError = (error) =>
  axios.isAxiosError(error) && handledAxiosResponseStatuses.has(error.response?.status);

export const shouldFilterAxiosError = (error) =>
  isAxiosNetworkError(error) || isAxiosCancellation(error) || isHandledAxiosResponseError(error);

const getExceptionValues = (event) => event?.exception?.values || [];

const getErrorText = (event, hint) => {
  const originalException = hint?.originalException;

  const originalMessage =
    typeof originalException === 'string' ? originalException : originalException?.message;
  const exceptionMessages = getExceptionValues(event).map(({ value }) => value);

  return [event?.message, originalMessage, ...exceptionMessages].filter(Boolean).join('\n');
};

const getEventPath = (event) => {
  const url = event?.request?.url;
  if (!url) return event?.transaction || '';

  try {
    return new URL(url).pathname;
  } catch {
    return url.split('?')[0];
  }
};

export const filterSentryEvent = (event, hint) => {
  const originalException = hint?.originalException;

  // Token refresh failures can affect authentication and should remain actionable.
  if (event?.tags?.source === 'token_refresh') return event;

  // Ignore expected API responses and client-side transport failures.
  if (shouldFilterAxiosError(originalException)) return null;

  const errorText = getErrorText(event, hint);
  const path = getEventPath(event);

  // Stripe is not required on these routes, so a load failure is non-actionable.
  if (stripeLoadErrorPattern.test(errorText) && ignoredStripeLoadErrorRoutes.includes(path)) return null;

  return event;
};
